import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { BreadcrumbModel, BObjectModel, BreadDik, EventsModel, QueovalParam } from '../../models';
import { CoreService } from '../../services';
import { HttpService } from '../../services';
import { DialogService } from '../../dialog';
import { AgendaQueovalService } from '../agenda.queoval.services';
import { ToastService } from '../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-rendez-vous-formateur',
  templateUrl: './rendezvousformateur.component.html',
  styleUrls: ['./rendezvousformateur.component.css']
})

export class RendezVousFormateurComponent implements OnInit {
  // Sauvegarde général (pas seulement le BO)
  public globalSave: boolean = false;
  public model: EventsModel;

  private openZoom: boolean = false;
  public zoom: boolean = false;
  
  @Input('param') param: QueovalParam;
  @Output() sendBreadcrump: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  @Output() sendEvent: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  /**
 * Bouton de fermeture de la modale de suppression
 */
  @ViewChild('closeDelete', { static: false }) closeDelete: ElementRef;

  constructor(
    private dialogservice: DialogService,
    private indParam: CoreService,
    private agenda: AgendaQueovalService,
    private httpService: HttpService,
    private toastservice: ToastService
  ) { }


  ngOnInit(): void {
    this.param.model.ShowRemoveButton = false;
    this.param.model.ShowSaveButton = false;
    this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETINIT/${this.param.model.IdDonneeFils}|RDV|${this.param.model.IdRelation}|${this.agenda.UserAgendaID}`).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.dialogservice.showSplash(false);
        if (data.DataRendezvous) {
          this.model = data;
        }
      }
    });
  }

  public SaveRdv(): void {
    this.globalSave = false;
    setTimeout(() => {
      this.globalSave = true;
    }, 0);
  }

  public SaveRdvAndOpenZoom(): void {
    this.openZoom = true;
    this.globalSave = false;
    setTimeout(() => {
      this.globalSave = true;
    }, 0);
  }

  public pageLoaded(): void {
    setTimeout(() => { this.zoom = document.getElementById('BtnZoom') ? true : false; }, 0);
  }


  // Link du stage sur la reservation apres la sauvgarde de la reservation
  public getIdBoRdv(BOEvent: BObjectModel): void {
    if (BOEvent && BOEvent.Error !== 'NOTVALID') {
      if (this.globalSave) {
        this.globalSave = false;
        this.dialogservice.showSplash(true);
        const model: EventsModel = this.model;
        model.Mode = 'SAVERDV';
        model.idUserEvent = this.agenda.UserAgendaID;
        model.EventId = BOEvent.IdDonneeFils;
        this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
          if (!data.HasError) {
            this.model = data;
            // Message succes + redirection
            if (this.openZoom) {
              const p: Array<BreadDik> = new Array<BreadDik>();
              p.push(new BreadDik('params', ''));
              const param: { params: Array<BreadDik>, model: BObjectModel } = { params: p, model: BOEvent };
              const breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('', 'zoom', param, 'Salle Virtuelle', true);
              this.sendBreadcrump.emit(breadCrumbItem);

            } else {
              this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
            }
          }
          this.dialogservice.showSplash(false);
        });
      }
    } else {
      this.globalSave = false;
      this.openZoom = false;
      this.dialogservice.showSplash(false);
    }
  }

  // Confirmation de la suppression du rendez-vous
  public confirmDelete(): void {
    const model: EventsModel = this.model;
    this.dialogservice.showSplash(true);
    model.Mode = 'DELETERDV';
    this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.model = data;
        this.dialogservice.showSplash(false);
        if (data.Alert.length > 0) {
          this.toastservice.showWarningToast(data.Alert);
        } else {
          // Message succes + redirection
          this.closeModalDelete();
          this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
          this.toastservice.showSuccessToast('Rendez-vous supprimé');
        }
      }
    });
  }

  // Fermeture de la modale de suppression
  public closeModalDelete(): void {
    this.closeDelete.nativeElement.click();
  }

}
